import React from 'react';
import CommandOutput from './CommandOutput';
import renderIf from 'render-if';

class CommandStart extends CommandOutput {
  constructor(command, ahaCommand) {
    super();
    this.command = command;
    this.ahaCommand = ahaCommand;
  }

  render() {
    return (
      <>
        <span className='command__headerTitle'>Command</span>
        {this.command.name}
        {renderIf(this.ahaCommand?.context)(() => (
          <span className='text-muted ml-2'>({this.ahaCommand.context})</span>
        ))}
      </>
    );
  }
}

export default CommandStart;
